/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Category_FertilizerInputs */

const vi_agri_category_fertilizer = /** @type {(inputs: Agri_Category_FertilizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bón`)
};

/**

* @param {Agri_Category_FertilizerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_category_fertilizer = /** @type {((inputs?: Agri_Category_FertilizerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Category_FertilizerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_category_fertilizer(inputs)
});